module.exports = __webpack_public_path__ + "static/media/close.bbe38fe3.png";